import styled from 'styled-components';

import { PaletteColor } from '@utils/types';

import {
  DesktopSizeOptions,
  MobileSizeOptions,
  TypographySizeOptions,
  TypographyWeightOptions,
  WeightOptions,
} from './utils';

export const StyledText = styled.span<{
  color: PaletteColor;
  variant?: TypographySizeOptions;
  weight?: TypographyWeightOptions;
}>`
  color: ${({ theme, color }) => theme.palette[color]} !important;

  ${({ variant }) => (variant ? `${DesktopSizeOptions[variant]}` : '')}
  ${({ weight }) => (weight ? `${WeightOptions[weight]}` : '')}

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    ${({ variant }) => (variant ? `${MobileSizeOptions[variant]}` : '')}
    ${({ weight }) => (weight ? `${WeightOptions[weight]}` : '')}
  }
`;
